import Link from "./link"
import * as React from "react"
import Spacer from "../components/spacer"

const Article = ({ article, className, textClassName, innerClassName }) => {
  return (
    <Link className={'link flex ' + className} target='_blank' to={(article?.website ? article.website : '/news/' + article.slug)}>
      <div className={'single--article ratio-4-2 w-100  p40 gap-10 flex flex-wrap bg-dark ' + innerClassName}>
        <div className='title-area w-100'>
          <p className={'m0 text-light h3 max-850 ' + textClassName}>{article.title}</p>
          <Spacer />
        </div>
        <div className='information flex w-100 mta'>
          <div className=''>
            <p className='m0 text-light'>{article.category?.name}</p>
            <p className='m0'>{article.meta?.publishedAt}</p>
          </div>
          <div className='w-50 mla flex align-bottom'>
            <p className="m0 radio-link active"><span className='ul-link'>{(article.website ? <>View Website</> : <>Read More</>)}</span></p>
          </div>
        </div>
      </div>
    </Link>
  )
}
export default Article
